var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user_descriptions" }, [
    _c(
      "div",
      { staticClass: "user_descr" },
      [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "user_pwa_text" } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.__t("PWA_" + this.article_type)) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("vue-editor", {
          attrs: { "editor-toolbar": _vm.editor_rules },
          model: {
            value: _vm.cur_article,
            callback: function ($$v) {
              _vm.cur_article = $$v
            },
            expression: "cur_article",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }